
I have a life motto I got from Andy Stanley of Northpoint Community Church" on a podcast called "Your Move".

The gist is that life choices are hard and a simple pro/con column won't sometimes be enough.

> Honest? Tension needs attention? Story? Glory?

# So what does this phrase mean?

*Honest:*

> Am I being honest with myself?

*Tension:*

> Is there tension that needs attention?

*Story:*

> What story do I want to tell?

*Glory:*

> How do I pay the "glory" forward?

# How to apply it?

Honesty?
- Why do I want to go back to NYC? Friends? FOMO?
- Is NYC the best environment for mental health?
- Am I being my best self in my current job?

Tension?
- Is this jitters I'm feeling FOMO?
- Why do I not enjoy being back in Atlanta compared to NYC?
- Listen to classical music instead?

Story?
- The story at work is great to tell ("I'm in global supply chain.")
- Working to build a product that is a net positive on the world


